import api from '~/services/api';
import PropTypes from 'prop-types';

const endPoint = 'employees';

// GET
export const getEmployees = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createEmployees = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateEmployees = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteEmployees = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

getEmployees.propTypes = {
  params: PropTypes.object.isRequired,
};

createEmployees.propTypes = {
  values: PropTypes.object.isRequired,
};

updateEmployees.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteEmployees.propTypes = {
  id: PropTypes.string.isRequired,
};
